<template src="./template.html" ></template>

<script>
// @ is an alias to /src
import {
  toJalaali
} from '../../functions/myDate';
import myAxios from '../../functions/myAxios'
import {
  showSnackbar
} from "../../components/MySnackbar/globalActions";
import MyListTable from './Table.vue'
import MyButtons from './Buttons.vue'
import MyDate from '../../components/MyDate.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
import setting from './setting.json'

const XLSX = require("xlsx")
//
// const propertyNames = Object.keys(person);
// console.log(propertyNames);
// const propertyValues = Object.values(person);
// console.log(propertyValues);
// const entries = Object.entries(person);
// console.log(entries);
export default {
  name: 'BankBill',
  methods: {
    async retrieveData() {
      this.rows = []
      if (!this.bank_account_id) {
        // alert('حساب بانکی را انتخاب کنید')
        return
      }
      this.loading = true
      try {
        // console.log(query);
        //
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}`,
          params: {
            mid: this.bank_account_id,
            from: this.date,
            to: this.date
          }
        });
        if (res && res.data && res.data.length) {
          // console.log(res.data);
          this.columns = setting['headers']
          this.rows = res.data
          // showSnackbar("اطلاعات با موفقیت از سیستم دریافت شد", 'success');
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async retrieveBankaccounts() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/bank_accounts/name`,
        });
        if (res && res.data) {
          // console.log(res);
          this.bank_accounts = res.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async removeData() {
      if (!this.bank_account_id) {
        alert('حساب بانکی را انتخاب کنید')
        return
      }
      if (window.confirm(`آیا مایل به حذف صورت حساب بانکی انتخابی هستید؟`) === true) {
        // setLoading(true);
        try {
          let res = await myAxios({
            method: 'DELETE',
            url: `/api/${this.route}`,
            params: {
              mid: this.bank_account_id
            }
          });
          if (res && res.data) {
            // console.log(res.data);
            if (res.data.acknowledged && res.data.deletedCount > 0) {
              let message = `اطلاعات مورد نظر با موفقیت حذف شد.`
              showSnackbar(message, 'success')
              this.back()
            } else if (res.data.acknowledged && res.data.deletedCount === 0) {
              let message = `اطلاعاتی برای حذف وجود ندارد.`
              showSnackbar(message, 'warning')
            } else {
              console.log(res.data);
              let message = `در عملیات حذف اطلاعات، خطایی رخ داده...`
              showSnackbar(message, 'warning')
            }
          }
        } catch (err) {
          console.log(`${this.route}.remove => ${err}`);
        }
      }
    },
    async saveToDB() {
      // console.log('saveToDB', this.rows);
      if (this.bank_account_id && this.rows.length) {
        //
        try {
          //
          let _data = {
            method: "POST",
            url: `/api/${this.route}`,
            data: {
              mid: this.bank_account_id,
              data: this.rows
            },
          }
          // this.loading = true
          // if (this.files.length === 1) {
          // if (window.confirm(`آیا مایل به ذخیره صورت حساب بانکی هستید؟`) === true) {
          await this.$store.dispatch('save', _data)
          this.$store.getters.saveData
          // this.back()
          // }
          // } else {
          //   await this.$store.dispatch('save', _data)
          //   this.$store.getters.saveData
          // }
          //
          // this.rows = []
        } catch (e) {
          console.error(e)
        } finally {
          // this.loading = false
        }
      }
    },
    async setDateValue(item) {
      this.date = item
      this.changeBank()
    },
    async changeBank() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        this.retrieveData()
      }, 200)
      // this.columns = setting['1']
      // this.file = null
      // this.rows = []
      // //
    },
    //
    myFileReader(file, cb) {
      let fileReader = new FileReader()
      fileReader.readAsBinaryString(file)
      fileReader.onload = (e) => {
        // console.log(e.target.result);
        let data = e.target.result
        let workbook = XLSX.read(data, {
          type: 'binary'
        })
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
          // console.log(rowObject);
          return cb({
            result: rowObject
          })
        })
      }
    },
    mellat(fr) {
      this.columns = setting['1']
      fr.reverse()
      for (let i in fr) {
        let row = fr[i]
        let obj = {
          bank_account_id: this.bank_account_id
        }
        // console.log(row);
        if (row['مبلغ گردش بستانکار'] === 0) {
          row['مبلغ گردش بستانکار'] = -Math.abs(row['مبلغ گردش بدهکار'])
        }
        obj['date'] = row['تاریخ']
        obj['time'] = row['زمان']
        obj['serial'] = String(row['شماره سریال'])
        obj['depositor'] = String(row['واریز کننده/ ذیتفع']).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        obj['description'] = String(row['شرح']).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        obj['price'] = Number(row['مبلغ گردش بستانکار'])
        //
        this.rows.push(obj)
      }
      //end
    },
    saderat(fr) {
      this.columns = setting['3']
      for (let i in fr) {
        let row = fr[i]
        let obj = {
          bank_account_id: this.bank_account_id
        }
        // console.log(row);
        const Variz = 'واريز'
        const bardasht = 'برداشت'
        if (row[Variz] === 0) row[Variz] = -Math.abs(row[bardasht])
        if (row['شماره پیگیری'] === undefined) row['شماره پیگیری'] = ''
        if (row['نام'] === undefined) row['نام'] = ''

        const Tariz = 'تاریخ'
        let _date = row[Tariz]
        row[Tariz] = String(_date).substring(0, 4) + '/' + String(_date).substring(4, 6) + '/' + String(_date).substring(6, 8)
        // console.log(row[Tariz]);
        obj['date'] = String(row[Tariz])
        obj['time'] = String(row['ساعت'])
        obj['serial'] = String(row['فيش/حواله'])
        obj['price'] = Number(row[Variz])
        obj['depositor'] = String(row['اطلاعات اضافی'])
        obj['description'] = String(row['شماره پیگیری'])
        // obj['name'] = String(row['نام'])
        //
        this.rows.push(obj)
      }
      //end
    },
    melli(fr) {
      this.columns = setting['2']
      let titleNames = [
        "", "date", "time", "", "type", "price", "", "depositor", "description", "serial", "", "", "", ""
      ]
      fr.map((row, i) => {
        if (i > 3) {
          let rows = Object.values(row)
          // dates.push(rows[1])
          let obj = {
            bank_account_id: this.bank_account_id
          }
          let propName = null
          rows.forEach((item, j) => {
            if ([1, 2, 4, 5, 7, 8, 9].includes(j)) {
              propName = titleNames[j]
              // obj[propName] = item
              if (j === 5) {
                // console.log(rows[4]);
                if (rows[4] === 'واریز') {
                  obj[propName] = Math.abs(this.rmCamma(item))
                } else if (rows[4] === 'برداشت') {
                  obj[propName] = -Math.abs(this.rmCamma(item))
                }
              } else {
                obj[propName] = item
              }
            }
          })
          this.rows.push(obj)
        }
      })
      //end
    },
    save() {
      if (this.files.length === 0) {
        alert('فایل/فایل های اکسل را انتخاب کنید.')
        return;
      }
      let ctr = 100 / this.files.length
      this.progressValue = 0
      this.files.forEach((file, i) => {
        let bank_account = this.bank_accounts.filter(b => file.name.includes(b.number))
        //
        if (bank_account.length) {
          this.myFileReader(file, (fr) => {
            this.bank_account_id = bank_account[0]._id
            this.rows = []
            this.columns = []
            //
            let bankName = bank_account[0].bank[0]
            //
            if (fr && fr.result && bankName === 'ملت') {
              this.mellat(fr.result)
            } else if (fr && fr.result && bankName === 'ملی') {
              this.melli(fr.result)
            } else if (fr && fr.result && bankName === 'صادرات') {
              this.saderat(fr.result)
            }
            this.saveToDB()
            this.progressValue += ctr
            // console.log(ctr);
            this.rows = []
            if (this.files.length === i + 1) {
              setTimeout(() => {
                this.back()
              }, 1000)
            }
          })
          //
        } else {
          console.log('no match bank_account_id');
        }
      })
    },
    show() {
      if (this.files.length === 0) {
        alert('فایل اکسل را انتخاب کنید.')
        return;
      }
      this.columns = []
      this.rows = []
      let bank_account = this.bank_accounts.filter(b => this.files[0].name.includes(b.number))
      if (bank_account.length) {
        let file = this.files[0]
        let bankName = bank_account[0].bank[0]
        //
        this.myFileReader(file, (fr) => {
          if (fr && fr.result && bankName === 'ملت') {
            this.mellat(fr.result)
          } else if (fr && fr.result && bankName === 'ملی') { //saderat
            this.melli(fr.result)
          } else if (fr && fr.result && bankName === 'صادرات') { //melli
            this.saderat(fr.result)
          }
        })
      } else {
        alert('no match')
      }
    },
    clearTable() {
      this.rows = []
    },
    back() {
      this.$router.push(`/`)
    },
  },
  async created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.columns = this.$store.getters.pageInfo.headers
    //
    this.retrieveBankaccounts()
  },
  data: () => ({
    loading: false,
    bank_accounts: [],
    bank_account_id: null,
    files: [],
    date: toJalaali(new Date()).date,
    columns: [], //BA(xlsx to json)
    rows: [], //BA(xlsx to json)
    // headers: [], //DB
    // data: [], //DB
    //
    progressValue: 0,
  }),
  components: {
    MyListTable,
    MyButtons,
    MyDate,
    MyBankaccounts,
  },
}
</script>



// ch(e) {
  //   console.log(e.target.files);
  // },
  // saveFile: function() {
    //   const data = JSON.stringify(this.rows)
    //   const blob = new Blob([data], {
      //     type: 'text/plain'
      //   })
      //   const e = document.createEvent('MouseEvents'),
      //     a = document.createElement('a');
      //   a.download = "test.json";
      //   a.href = window.URL.createObjectURL(blob);
      //   a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      //   e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      //   a.dispatchEvent(e);
      // },
